<template>
  <iframe
    v-if="videoUrl"
    :width="$vuetify.breakpoint.xs ? '100%' : 640"
    height="390"
    :src="videoUrl"
    frameborder="0"
    title="YouTube video player"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
  />
  <div v-else-if="error" role="alert">{{ error }}</div>
</template>
<script>
export default {
  name: "MediaTpl",

  props: {
    content: { type: String, required: true }
  },
  data() {
    return {
      parsedContent: null,
      videoUrl: null,
      error: null
    };
  },
  watch: {
    content: {
      immediate: true,
      handler: "handleParsedContent"
    }
  },
  methods: {
    normalizeProtocol(url) {
      if (typeof url !== "string" || !url.trim()) {
        throw new Error("Missing video URL");
      }

      let normalized = url.trim();
      if (/[\s\\]/.test(normalized)) {
        throw new Error("Invalid video URL");
      }

      if (normalized.startsWith("//")) {
        normalized = `https:${normalized}`;
      } else if (!/^[a-z][a-z0-9+.-]*:/i.test(normalized)) {
        normalized = `https://${normalized}`;
      } else if (/^[^/?#:\s]+:\d+(?:[/?#]|$)/.test(normalized)) {
        // A bare hostname with a port is not a URL scheme.
        normalized = `https://${normalized}`;
      }

      if (
        !/^https?:\/\/[^/]/i.test(normalized) ||
        /^https?:\/\/https?:\/\//i.test(normalized)
      ) {
        throw new Error("Video URL must use HTTP or HTTPS");
      }

      const parsedUrl = new URL(normalized);
      if (!parsedUrl.hostname || parsedUrl.username || parsedUrl.password) {
        throw new Error("Invalid video URL");
      }
      return parsedUrl.href;
    },

    handleParsedContent() {
      this.parsedContent = null;
      this.videoUrl = null;
      this.error = null;
      try {
        let rawUrl = this.content;
        if (typeof rawUrl === "string" && rawUrl.trim().startsWith("{")) {
          this.parsedContent = JSON.parse(rawUrl);
          rawUrl = this.parsedContent.url;
        }

        const videoUrl = new URL(this.normalizeProtocol(rawUrl));
        const hostname = videoUrl.hostname.toLowerCase();
        if (hostname === "youtube.com" || hostname.endsWith(".youtube.com")) {
          if (videoUrl.pathname === "/watch") {
            const videoId = videoUrl.searchParams.get("v");
            if (!videoId) {
              throw new Error("Missing YouTube video ID");
            }
            videoUrl.pathname = `/embed/${encodeURIComponent(videoId)}`;
            videoUrl.searchParams.delete("v");
          } else if (/^\/shorts\/[^/]+\/?$/.test(videoUrl.pathname)) {
            videoUrl.pathname = videoUrl.pathname.replace(
              "/shorts/",
              "/embed/"
            );
          }
        } else if (hostname === "youtu.be") {
          if (!/^\/[^/]+\/?$/.test(videoUrl.pathname)) {
            throw new Error("Missing YouTube video ID");
          }
          videoUrl.hostname = "www.youtube.com";
          videoUrl.pathname = `/embed/${videoUrl.pathname.split("/")[1]}`;
        } else if (hostname === "vimeo.com" || hostname === "www.vimeo.com") {
          videoUrl.hostname = "player.vimeo.com";
          videoUrl.pathname = `/video${videoUrl.pathname}`;
        }

        this.videoUrl = videoUrl.href;
        if (this.parsedContent) {
          this.parsedContent.url = this.videoUrl;
        }
      } catch (error) {
        console.error("Unable to parse video URL", error);
        this.error = this.$t("errors.errorParsingVideoUrl");
      }
    }
  }
};
</script>
